<template>
  <div class="home-container">
    <EntitySecond :itemData="storeInfo"/>
    <Nav :navData="menuInfo"/>
    <div v-for="({componentIndex,componentNeedData},index) in cardComponentList" :key="index">
      <component :is="componentIndex"
                 :data="componentNeedData"
                 v-if="(componentNeedData.items && componentNeedData.items.length>0 || componentNeedData.cardType == 40601 || componentNeedData.contentType == 'NEW')"></component>
      <div class="g-bottom-divider"
           v-if="(componentNeedData.cardType ===40301||componentNeedData.cardType ===40401)&&componentNeedData.items[0]&&componentNeedData.items[0].itemType!==30501&&(index!==cardComponentList.length-1)"></div>
    </div>
    <!-- <div class="bottom-footer" v-if="cardList.length>1">没有更多内容了</div> -->
    <zs-infinite ref="infinite" @infinite="onLoadData" :isAutoLoad="true" noResultText=""
                 no-more-text="没有更多内容了"></zs-infinite>
  </div>
</template>

<script>
  import Api from "../../../service/api"
  import Cookies from 'js-cookie'
  import pv from '../../../service/pingback/pv'
  import global from '../../../components/Global'
  import Nav from '../../../components/cards/Nav'
  import store from "../../../store";
  import {mapGetters} from 'vuex'
  import EntitySecond from '../../../components/items/Entity2'

  export default {
    components: {
      Nav,
      EntitySecond,
    },
    data() {
      return {
        pageData: {},
        cardList: [],
        cardComponentList: [],
      }
    },
    methods: {
      async getHomeData(pageKey) {
        let testJson = await Api.read(pageKey, 'home', true);
        this.pageData = testJson && testJson.pages[0];
        this.cardList = this.pageData && this.pageData.cards || [];
        this.cardComponentList = this.$renderCardComponentList(this.cardList);
        let docTitle = this.pageData && this.pageData.showData && this.pageData.showData.texts && this.pageData.showData.texts[0].text || '知识店铺';
        this.$store.dispatch('category/setNvTitle', '知识店铺')
        //存储店铺和菜单数据
        document.title = '爱奇艺知识'
        const channel = this.$getParameterByName("social_platform")
        if (channel) {
          // global.channel = this.$getUrlParamsArr("social_platform").pop();
          global.channel = channel
        }
        let homePageUrl = testJson && testJson.extend && testJson.extend.homePageUrl;

        if (homePageUrl) {
          Cookies.set('homePageUrl', homePageUrl + "&social_platform=" + global.channel);
        }
        Cookies.set('lastPage', location.href);
        let qiyiId = testJson && testJson.extend && testJson.extend.qiyiId;
        if (qiyiId) {
          Cookies.set('qiyiId', qiyiId)
        }

        // let shopTitle = this.cardList && this.cardList[0]
        //   && this.cardList[0].items && this.cardList[0].items[0]
        //   && this.cardList[0].items[0].showData
        //   && this.cardList[0].items[0].showData.texts
        //   && this.cardList[0].items[0].showData.texts[0]
        //   && this.cardList[0].items[0].showData.texts[0].text || '知识店铺';
        let shopId = testJson && testJson.storeInfo && testJson.storeInfo.key || " ";
        const storeInfo = (testJson && testJson.storeInfo) || {};

        window.pageTitle = docTitle
        window.storeInfo = storeInfo

        let opt = {
          rpage: `knowledge_h5_shop_${shopId}_${docTitle}`,
          shop_id: shopId
        }
        pv.send(opt);
        Cookies.set('shopTitle', shopId);

        // 存储店铺和菜单信息
        store.dispatch('category/storeInfo', {
          storeInfo: testJson && testJson.storeInfo || {}
        })
        store.dispatch('category/menuInfo', {
          menuInfo: testJson && testJson.tabs || []
        })
        return testJson
      },
      /**
       * 触底回调函数
       */
      async onLoadData() {
        try {
          let param = this.$route.params.pageId;
          let arr = []
          let homeData
          if (param) {
            arr = param.split('.html');
            homeData = await this.getHomeData(arr[0]);
          }
          this.$store.dispatch('category/home', true)
          const $infinite = this.$refs.infinite
          let pages = homeData.pages
          let cards = pages[0] && pages[0].cards || []
          if (cards.length) {
            $infinite.complete()
          }
        } catch (err) {
          throw err
        }
      }
    },
    computed: {
      ...mapGetters('category', {
        storeInfo: 'getStoreInfo',
        menuInfo: 'getMenuInfo'
      }),
    },
    created() {
      this.$store.dispatch('category/home', true);
      // this.shopData = shopData
      // if(this.storeInfo.key){
      //     pv.send({
      //         rpage:`knowledge_h5_shop_${this.storeInfo.key}_全部课程`,
      //     })
      // }
    },
    mounted() {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="less">
  .home-container {
    .zs-infinite-loading-container {
      background-color: #fff;
      padding-bottom: 10px;
    }
  }
</style>
